module.exports = __webpack_public_path__ + "static/media/undraw_hombre.6a13d223.png";